import cn from "classnames";
import Menu from "../../images/menu-module.png";
import MenuActive from "../../images/menu-module-current.png";

import styles from "./Language.module.css";

function LanguageMenuItem({
  langNameText,
  selected = false,
  active = false,
  isBold = false,
  disabled = false,
  style,
  ...rest
}) {
  return (
    <div
      className={styles.item}
      style={{
        backgroundImage: `url("${active ? MenuActive : Menu}")`,
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "all",
        ...style,
      }}
      {...rest}
    >
      <span className={cn(styles.text, selected ? styles.checkmark : null)}>
        {isBold ? <strong>{langNameText}</strong> : langNameText}
      </span>
    </div>
  );
}

export default LanguageMenuItem;
